/**
 * Werkplaatsinstructie + lange omschrijving in één Unit4-veld (products.assemblyInstruction).
 *
 * De lange productomschrijving (NL, anders EN) wordt bij het opslaan van de productgegevens
 * onderaan de werkplaatsinstructie geplakt, achter een vaste markeringsregel. Bij het opnieuw
 * samenvoegen wordt het oude omschrijvingsdeel eerst weggehaald, zodat het nooit dubbel komt.
 * De omschrijving is in de instructie alleen-lezen: bewerken gebeurt in het veld "Lange omschrijving".
 */
export const LONG_DESCRIPTION_MARKER = '=== PRODUCTOMSCHRIJVING ===';

const MARKER_RE = /^[ \t]*=== ?PRODUCTOMSCHRIJVING ?===[ \t]*$/im;

/** Splitst een opgeslagen instructietekst in het instructiedeel en het (eventuele) omschrijvingsdeel. */
export function splitAssemblyInstruction(text: string | null | undefined): {
  instruction: string;
  longDescription: string;
} {
  const t = text ?? '';
  const m = MARKER_RE.exec(t);
  if (!m) return { instruction: t.replace(/\s+$/, ''), longDescription: '' };
  return {
    instruction: t.slice(0, m.index).replace(/\s+$/, ''),
    longDescription: t.slice(m.index + m[0].length).trim(),
  };
}

/** Kiest de omschrijving die onderaan de instructie komt: NL, anders EN. */
export function pickLongDescription(nl: string | null | undefined, en: string | null | undefined): string {
  return (nl ?? '').trim() || (en ?? '').trim();
}

/**
 * Bouwt de op te slaan instructietekst: instructiedeel (zonder oud omschrijvingsdeel) + markering +
 * omschrijving. Zonder omschrijving blijft alleen het instructiedeel over (zonder markering).
 */
export function mergeAssemblyInstruction(
  instruction: string | null | undefined,
  longDescription: string | null | undefined,
): string {
  const body = splitAssemblyInstruction(instruction).instruction;
  const desc = (longDescription ?? '').trim();
  if (!desc) return body;
  return body ? `${body}\n\n${LONG_DESCRIPTION_MARKER}\n${desc}` : `${LONG_DESCRIPTION_MARKER}\n${desc}`;
}
